import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { Toaster } from "sonner"
import App from "./App"
import { queryClient } from "./lib/queryClient"
import "./index.css"

import { HelmetProvider } from "react-helmet-async"

const rootElement = document.getElementById("root")!

const AppTree = (
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
          <Toaster
            position="top-center"
            toastOptions={{
              duration: 4000,
              className: "text-sm",
            }}
          />
        </BrowserRouter>
        {import.meta.env.VITE_QUERY_DEVTOOLS === "true" && (
          <ReactQueryDevtools initialIsOpen={false} />
        )}
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>
)

// Deliberately createRoot, never hydrateRoot — even though prerender.js fills
// #root with markup. That markup is a *serialized client render* (puppeteer
// page.content()), not React SSR output, so it lacks the <!-- --> text-node
// markers hydration depends on. hydrateRoot() therefore mismatched on every
// page and threw the whole tree away anyway; this just skips that wasted pass.
// React replaces the existing DOM in a single commit, so there is no blank
// frame, and crawlers still receive the fully prerendered HTML.
ReactDOM.createRoot(rootElement).render(AppTree)
